/* ==========================================================================
   PUREGANIC — Collapsible rows open as a DRAWER (congruent with Nutrition facts)
   The product page's native accordion rows (Description, etc.) are made to open
   in a drawer instead of expanding inline.

   Robustness (fixes the "blank on first click / native tries to open too" bug):
     • We capture each row's content ONCE at load (cloned), so the drawer is never
       blank — it never depends on the live element at click time.
     • We intercept the click in the CAPTURE phase with stopImmediatePropagation, so
       the native <details is="accordion-disclosure"> can't toggle/animate at all.
   Scoped to .product-info__accordion; the Nutrition-facts row keeps its own drawer.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__pgAccDrawers) return;
  window.__pgAccDrawers = true;

  var drawer, panel, titleEl, bodyEl, lastToggle;

  function build() {
    drawer = document.createElement('div');
    drawer.className = 'pg-accdrawer';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="pg-accdrawer__backdrop" data-pgacc-close></div>' +
      '<aside class="pg-accdrawer__panel" role="dialog" aria-modal="true" tabindex="-1">' +
        '<header class="pg-accdrawer__head">' +
          '<p class="pg-accdrawer__title"></p>' +
          '<button type="button" class="pg-accdrawer__close" data-pgacc-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="pg-accdrawer__body"></div>' +
      '</aside>';
    document.body.appendChild(drawer);
    panel = drawer.querySelector('.pg-accdrawer__panel');
    titleEl = drawer.querySelector('.pg-accdrawer__title');
    bodyEl = drawer.querySelector('.pg-accdrawer__body');
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-pgacc-close]'), function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function open(title, storedContent, toggle) {
    if (!drawer) build();
    lastToggle = toggle;
    titleEl.textContent = title;
    bodyEl.innerHTML = '';
    bodyEl.appendChild(storedContent.cloneNode(true)); // clone the stored copy each open
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('pg-accdrawer-open');
    if (panel) panel.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('pg-accdrawer-open');
    var done = function () { drawer.hidden = true; panel.removeEventListener('transitionend', done); };
    if (panel) panel.addEventListener('transitionend', done);
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 400);
    if (lastToggle && lastToggle.focus) lastToggle.focus();
  }

  function wire(scope) {
    (scope || document).querySelectorAll('.product-info__accordion.accordion').forEach(function (acc) {
      if (acc.dataset.pgAccReady) return;
      acc.dataset.pgAccReady = '1';
      if (acc.hasAttribute('data-pg-nutri')) return; // nutrition has its own drawer
      var summary = acc.querySelector('summary');
      var content = acc.querySelector('.accordion__content');
      if (!summary || !content) return;

      var span = acc.querySelector('.accordion__toggle span');
      var title = span ? span.textContent.trim() : '';
      // Capture the content ONCE, now — so the drawer is never blank and never depends on
      // the live element's animation/open state at click time.
      var stored = content.cloneNode(true);

      // Capture phase + stopImmediatePropagation → the native accordion never toggles.
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (acc.open) acc.open = false;
        open(title, stored, summary);
      }, true);
    });
  }

  function init() { wire(document); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();
